import Vue from 'vue'
import { useUniverseStore } from '@/stores/universe'

Vue.filter('money', (value, currencyId = null, decimals = true) => {
  const universeStore = useUniverseStore()
  const currencies = universeStore.getCurrencies
  if (!currencyId) {
    currencyId = universeStore.getSettingByPath('currency', null)
  }
  const currency = currencies.find((c) => c.id === currencyId)
  return `${parseFloat(value).toLocaleString(undefined,
    { minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: decimals ? 2 : 0, style: 'currency', currency: currency.iso }
  )}`
})
